<template>

<form>
    <input type="text" id="uid" placeholder="UID" v-model="uid" />
    <input type="button" @click="adminize" value="Adminize"/>
    <div v-html="res"></div>
</form>

</template>

<script>

import firebase from 'firebase'

export default {
  name: 'Adminizer',

  data () {
    return {
        uid: '',
        res: ''
    }
  },

  methods: {

      adminize() {
        const fnUserModify = firebase.app().functions(process.env.VUE_APP_FN_HOSTING).httpsCallable('userAdminize')
        fnUserModify({uid: this.uid}).then((result) => {
            this.res = JSON.stringify(result)
        }).catch((error) => {
            this.res = error.message
        })
      }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Adminizer.vue